import createIcon from '../../createIcon';

/**
 * @component @name Circle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ3IDIgMiA2LjQ3IDIgMTJDMiAxNy41MyA2LjQ3IDIyIDEyIDIyQzE3LjUzIDIyIDIyIDE3LjUzIDIyIDEyQzIyIDYuNDcgMTcuNTMgMiAxMiAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Circle = createIcon('Circle', [
  [
    'path',
    {
      d: 'M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2Z',
      key: 'arly8y',
    },
  ],
]);

export default Circle;
